export default __webpack_public_path__ + "static/media/launchpad.14fdcb99.svg";